<template>
	<div class="m-video">
		<video :src="unitData.video_url" :poster="unitData.image_url"></video>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-video {
		margin: 0 12px;
		
		video {
			width: 100%;
			height: 198px;
			border-radius: 8px;
			background: #000;
		}
	}
</style>
